import { gql, useMutation } from '@apollo/client';
import { IconButton, Text, Tooltip } from '@radix-ui/themes';
import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

const REINVITE = gql`
  mutation sendInterviewInvitation($applicationId: String!) {
    sendInterviewInvitation(applicationId: $applicationId)
  }
`;

const ReInvite = (props: { application: { id: string; job: { id: string } }; className?: string }) => {
  const { t } = useTranslation();
  const [reinviteApplication, { loading }] = useMutation(REINVITE);

  const application = props.application;
  const reinviteClick = () => {
    if (application.job.id && application.id) {
      reinviteApplication({
        variables: {
          applicationId: application.id,
        },
      })
        .then((response) => {
          if (response.data && response.data.sendInterviewInvitation) {
            reinviteToast(true);
          }
        })
        .catch((err) => {
          console.error(err);
          // TODO: Show error message when global error toast is removed.
          // reinviteToast(false, err.message);
        });
    }
  };
  const reinviteToast = (success: boolean, errorMessage = '') => {
    if (success) {
      toast.success(t('reInvite.successTitle'), { description: t('reInvite.successDescription') });
    } else {
      toast.error(t('reInvite.errorTitle'), { description: errorMessage });
    }
  };

  return (
    <Tooltip content={<Text size="3">{t('reInvite.tooltip')}</Text>}>
      <IconButton
        size="3"
        variant="soft"
        color="gray"
        className={props.className ?? ''}
        loading={loading}
        onClick={reinviteClick}
      >
        <Send size={20} />
      </IconButton>
    </Tooltip>
  );
};

export default ReInvite;
